import dayjs from "dayjs";

export const getFormattedDate = (date: string, dateFormat: string) => {
  return dayjs(date).format(dateFormat);
};
